import queryString from 'query-string';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { Page, IssueTypeScheme } from './IssueTypeScheme.types.tsx';
import { toApiUrlTransformer, fromUrlTransformer } from './toApiUrlTransformer.tsx';

const PACKAGE_NAME = 'jiraAdminPagesIssueTypeSchemesDirectory';

export const getIssueTypeSchemes = async (qs: string): Promise<Page<IssueTypeScheme>> => {
	const filter = fromUrlTransformer(queryString.parse(qs));
	const query = queryString.stringify(toApiUrlTransformer(filter));

	try {
		return await performGetRequest(`/rest/api/3/issuetypescheme?${query}`);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getIssueTypesRequest',
				packageName: PACKAGE_NAME,
				teamName: 'morphinecake',
			},
			sendToPrivacyUnsafeSplunk: true,
		});

		throw error;
	}
};
